/**
 * The column the teams are filtered by their members, which is also its query param in the URL.
 * It filters either by the number of members or by specific members, never by both at once.
 */
export const TEAMS_MEMBERS_FILTER_COLUMN = "users";

/** The column the teams are filtered by creation date, which is also its query param in the URL */
export const TEAMS_CREATED_FILTER_COLUMN = "creationDate";

/** The column the teams are filtered by workspace role, which is also its query param in the URL */
export const TEAMS_ROLE_FILTER_COLUMN = "workspaceRole";

/** The columns the teams can be filtered by, in the order of their chips */
export const TEAMS_FILTER_COLUMNS = [TEAMS_MEMBERS_FILTER_COLUMN, TEAMS_CREATED_FILTER_COLUMN, TEAMS_ROLE_FILTER_COLUMN];

/** A column the teams can be filtered by */

/** The label of the chip to filter the teams by their members */
export const TEAMS_MEMBERS_FILTER_LABEL = "Members";

/** The label of the option to filter the teams by their number of members */
export const TEAMS_MEMBER_COUNT_FILTER_LABEL = "Number of members";

/** The label of the option to filter the teams by the members they contain */
export const TEAMS_SPECIFIC_MEMBERS_FILTER_LABEL = "Specific members";

/** The label of an applied member who is not in the workspace, e.g. one who left it or is in a link of another workspace */
export const UNKNOWN_MEMBER_LABEL = "Unknown member";